import { styled } from '@ui-furniture/style';

export const RowItem = styled.div`
  flex: 1;
`;
